<div class="container">
  <div class="title">{{ data.title || 'Configurer votre photo de profil' }}</div>

  <div class="body" fxLayout="column" fxLayoutAlign="start stretch">
    <image-cropper
      format="jpeg"
      [imageChangedEvent]="data.imageChangedEvent"
      output="base64"
      (imageCropped)="imageCropped($event)"
    ></image-cropper>
  </div>

  <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button text="Annuler" btnType="text" (click)="onNoClick()"></app-button>
    <app-button text="Enregistrer" (click)="onSave()"></app-button>
  </div>
</div>
